import { useEffect, useState } from "react";
import moment from "moment";

import { Page, Container } from "@/ui/Layout/Page";
import { Grid } from "@/ui/Grid";
import { Card } from "@/ui/Card";
import { getCampaigns } from "@/api/campaigns";
import { ButtonTypes, Status } from "@/ui/types";
import { getSessionToken } from "@/api/auth";
import Button from "@/ui/Button";
import { EmptyState } from "@/ui/Layout";
import { Loading } from "@/ui/Layout/Loading";
import { CreateSiteModal } from "./CreateSiteModal";

import { LAUNCH_OS_ICON } from "@/brand";
export const Sites = ({ name = "" }) => {
  const [siteList, setSiteList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isCreateOpen, setIsCreateOpen] = useState<boolean>(false);

  // get the siteList from the server
  const loadSites = async () => {
    const token = getSessionToken();
    const response = await getCampaigns({ token, type: "site" });
    // const response = await getCampaigns({ token, type: "site" });
    if (response) {
      // convert the response to the format that the Card components expect
      const seqs = response
        ?.filter(({ deleted }) => !deleted)
        .map((site: any) => {
          return {
            id: site.id,
            label: site.name,
            caption: `Last Updated: ${moment(site.updatedAt).fromNow()}`,
            img: (
              <img
                className="w-[42px] h-[42px] flex-none rounded-full overflow-hidden object-cover"
                src={LAUNCH_OS_ICON}
                alt=""
              />
            ), // funnel.screensnhot
            status: Status.INPROGRESS,
          };
        });

      setSiteList(seqs);
    }
    setIsLoading(false);
  };

  // load the siteList when the page loads
  useEffect(() => {
    loadSites();
  }, []);

  return (
    <Page
      topBar={{
        page: [{ label: name }],
        items: (
          <div className="flex gap-2">
            <a href="/connect-claude">
              <Button label="Connect Claude" type={ButtonTypes.SOFT} />
            </a>
            <Button label="+ Create a Site" type={ButtonTypes.OUTLINED} onClick={() => setIsCreateOpen(true)} />
          </div>
        ),
      }}
    >
      <Container>
        {isCreateOpen && <CreateSiteModal setIsOpen={setIsCreateOpen} />}
        {isLoading && <Loading type="gallery" />}
        {!isLoading && !Boolean(siteList.length) && (
          <EmptyState
            title="No Sites Yet"
            description="Get started by creating a new site."
            showImage={false}
          >
            <Button label="Create a Site" type={ButtonTypes.DEFAULT} onClick={() => setIsCreateOpen(true)} />
          </EmptyState>
        )}
        {!isLoading && Boolean(siteList.length) && (
           <Grid className="pb-6">
            {/* Can we change to Gallery View - let's me toggle views */}
            {siteList.map(
              (
                {
                  id,
                  label,
                  caption,
                  img = "[logo]",
                  status,
                  // sharedWith,
                  taskDetails,
                },
                key
              ) => {
                return (
                  <Card
                    key={key}
                    label={label}
                    caption={caption}
                    image={img}
                    href={`/sites/${id}`}
                    status={status}
                    taskDetails={taskDetails}
                  />
                );
              }
            )}
          </Grid>
        )}
      </Container>
    </Page>
  );
};
